export default {
  'user.login': 'вход',
  'user.signup': 'Зарегистрироваться',
  'user.profile': 'Профиль',
  'user.reset_password': 'Изменить пароль',
  'user.user_management': 'Управление пользователями',
  'user.send_verification_sms': 'Отправить подтверждение SMS',
  'user.verification_check': 'контрольная проверка',
  'user.change_password': 'Изменить пароль',
  'user.username_email': 'Имя пользователя / Эл.адрес',
  'user.email': 'Эл.адрес',
  'user.changepass': 'Ваш пароль успешно изменен!',
  'user.phone': 'Мобильный без нуля',
  'user.password': 'Пароль',
  'user.forgetpassword': 'Забыли пароль ?',
  'user.loginwithgoogle': 'Войти через Google',
  'user.createaccount': 'Регистрация',
  'user.offerservices': 'Мы предлагаем все туристические услуги',
  'user.welcome': 'Добро пожаловать в Доньяро',
  'user.firstname': 'Имя',
  'user.lastname': 'Фамилия',
  'user.agreemessage': 'я согласен с',
  'user.rotapolicy': 'Я согласен с правилами Трипси',
  'user.rotapolicy_tripord': 'Я соглашаюсь с правилами Tripord',
  'user.rotacopyright': 'Авторские права © 2018',
  'user.emptypass': 'Пожалуйста, введите старый или новый пароль',
  'user.oldpass': 'Старый пароль не совпадает!',
  'user.employeeadd': 'Сотрудник успешно добавлен!',
  'user.tryagain': 'Пожалуйста, попробуйте снова',
  'user.changepasssuccess': 'Ваш пароль не был изменен',
  'user.newpass': 'Пожалуйста, введите новый пароль',
  'user.loginerror': 'Логин или пароль неверны',
  'user.userlock': 'Имя пользователя заблокировано',
  'user.changepasserror': 'Новый пароль и введенный новый пароль не совпадают',
  'user.tripsi': 'Доньяро',
  'user.tripord': 'Tripord',
  'user.userpoint': 'Пользовательская точка',
  'user.duplicatedusername': 'Email дублирован',
  'user.signuperror': 'Email должен быть уникальным',
  'user.forgetyour': 'Забывать',
  'user.createyour': 'создать свой ',
  'user.account': 'учетная запись',
  'user.registerwith': 'или зарегистрируйтесь с',
  'user.acceptrules': 'Пожалуйста, примите правила сайта',
  'user.favourites': 'Избранное',
  'user.nograde': 'Без оценки',
  'user.phone': 'Телефоно',
  'user.has_account': 'У меня есть аккаунт Трипси',
  'user.has_account_tripord': 'У меня есть аккаунт Tripord',
  'user.donthaveaccount': 'Не регистрировались раньше?',
  'user.signup_free': 'Бесплатно зарегестрироваться',
  'user.pass_recovery': 'Восстановление пароля',
  'user.remember_password': 'Вы помните свой пароль?',
  'authentication.slugone':
    'Самый надежный поставщик туристических услуг в Иране',
  'user.otplogin': 'Accedi inviando un codice Tramit отправить сообщение',
  'user.otplogintitle': 'Одноразовый пароль',
  'user.incorrectcode': 'Введенный код неверен',
  'user.untilresend': 'До повторной отправки',
  'user.phoneoremail': 'Электронная почта или мобильный телефон',
  'user.loginwithusername': 'Войти с именем пользователя',
  'user.sendcode': 'Отправить код',
  'user.sendagain': 'Отправить',
  'user.justwelcome': 'Авторизоваться',
};
